module.exports = __webpack_public_path__ + "img/lvshi.01b4ac4f.png";